import { View, Text } from "@react-pdf/renderer";
import styles from "./styles";
import FaNum from "./FaNum";

export default function CustomerCard({ order }) {
  const u = order.userAddress;

  return (
    <View style={styles.customerCard}>
      <Text style={styles.cardTitle}>
        گیرنده: {u.fname} {u.lname}
      </Text>

      <Text style={styles.cardText}>
        <FaNum>آدرس: {u.province} - {u.city} - {u.address}</FaNum>
      </Text>

      <Text style={styles.cardText}>
        <FaNum>موبایل: {u.mobile}</FaNum>
      </Text>

      <Text style={styles.cardText}>
        <FaNum>{u.postal_code || " - "}: کدپستی</FaNum>
      </Text>
    </View>
  );
}
